/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Tooltip from '../common/Tooltip';
import {capitalizeFirstLetter} from "../../utils";

const propTypes = {
    settingsData: PropTypes.object.isRequired,
    onSettingChange: PropTypes.func.isRequired,
};

class SuppleSettings extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isError: false,
        };
    }

    handleServiceCheckboxChange = (event, service) => {
        const isChecked = event.target.checked;
        let updatedServices;
        if (isChecked) {
            updatedServices = [...this.props.settingsData.ALLOWED_SERVICES_ON_SIGNUP, service];
        } else {
            updatedServices = this.props.settingsData.ALLOWED_SERVICES_ON_SIGNUP.filter(s => s !== service);
        }
        this.props.onSettingChange({
            ALLOWED_SERVICES_ON_SIGNUP: updatedServices
        });
    }

    render() {
        const { settingsData, onSettingChange } = this.props;
        const badFeedbackOptions = [];
        for (let i = 1; i <= 10; i += 1) {
            badFeedbackOptions.push({ value: i, label: i.toString() });
        }

        const strikesOptions = [];
        for (let i = 0; i <= 20; i += 1) {
            strikesOptions.push({ value: i, label: i.toString() });
        }

        const ratingOptions = [];
        for (let i = 0; i <= 5; i += 1) {
            ratingOptions.push({ value: i, label: i.toString() });
        }

        const servicesList =
            this.props.servicesStructure && Object.keys(this.props.servicesStructure).filter(item => !!item);

        return (
            <div className="system-settings-section">
                <div className="system-settings-section__header">
                    <div className="system-settings-section__title">
                        Supply Settings
                    </div>
                </div>
                <div className="system-settings-section__content">
                    <div className="system-settings-section__subtitle">
                        Onboarding
                    </div>
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Enable Central Onboarding</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Enable 'Central Onboarding' proccess for new workers on the platform">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.CENTRAL_ONBOARDING_ENABLED
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    CENTRAL_ONBOARDING_ENABLED:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Onboarding e-mail</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Email address from which freelancers will receive emails during onborading process.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        className="settings-textfield"
                                        type="text"
                                        defaultValue={
                                            settingsData.ONBOARDING_EMAIL
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                ONBOARDING_EMAIL:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Induction session address</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Default address for all scheduled induction sessions.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <textarea
                                        className="settings-textfield"
                                        rows={3}
                                        defaultValue={
                                            settingsData.INDUCTION_SESSION_ADDRESS
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                INDUCTION_SESSION_ADDRESS:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Interviews online</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Send information depending on the type of interview. If enabled, send only online interview information.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.INTERVIEWS_ONLINE
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    INTERVIEWS_ONLINE:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Enable interviews</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Enable interview system for new workers on the platform">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.INTERVIEW_ENABLED
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    INTERVIEW_ENABLED:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Enable presentation</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Enable presentation test for new workers on the platform">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.PRESENTATION_ENABLED
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    PRESENTATION_ENABLED:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Enable communities</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Enable communities for workers so they can collect points and rewards">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.COMMUNITIES_ENABLED
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    COMMUNITIES_ENABLED:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Enable worker feedbacks</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Enable workers to leave feedbacks on their shift">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.FREELANCER_FEEDBACK_ENABLED
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    FREELANCER_FEEDBACK_ENABLED:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Is agency onboarding?</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="When the agency onboarding mode is enabled, the work history requirement during registration in the mobile app will be automatically disabled.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <label className="settings-checkbox">
                                        <input
                                            type="checkbox"
                                            checked={
                                                settingsData.IS_ONBOARDING
                                            }
                                            onChange={event => {
                                                onSettingChange({
                                                    IS_ONBOARDING:
                                                        event.target.checked,
                                                });
                                            }}
                                        />
                                        <div className="settings-checkbox__container">
                                            <div className="settings-checkbox__indicator" />
                                            <span className="settings-checkbox__yes-label">
                                                Yes
                                            </span>
                                            <span className="settings-checkbox__no-label">
                                                No
                                            </span>
                                        </div>
                                    </label>
                                </td>
                            </tr>
                            {servicesList && (
                                <tr>
                                    <td>
                                        <span>Allowed services on signup</span>
                                        <span className="table-settings__tooltip">
                                            <Tooltip tooltip="Enables the allocation of workers from selected sectors within an agency. Applies only to workers who did not indicate a preference for a branch during registration. Does not apply to the national branch.">
                                                <i className="icon icon-infomation-circle" />
                                            </Tooltip>
                                        </span>
                                    </td>
                                    <td>
                                        <table className="internal-table">
                                            <tbody>
                                            {servicesList.map(service => (
                                                <tr key={service}>
                                                    <td>
                                                        <div className="settings-checkbox__description">{capitalizeFirstLetter(service)}:</div>
                                                    </td>
                                                    <td>
                                                        <label className="settings-checkbox">
                                                            <input
                                                                className="checkbox-item"
                                                                type="checkbox"
                                                                checked={settingsData.ALLOWED_SERVICES_ON_SIGNUP?.includes(service)}
                                                                onChange={event => this.handleServiceCheckboxChange(event, service)}
                                                            />
                                                            <div className="settings-checkbox__container">
                                                                <div className="settings-checkbox__indicator" />
                                                                <span className="settings-checkbox__yes-label">
                                                                    Yes
                                                                </span>
                                                                <span className="settings-checkbox__no-label">
                                                                    No
                                                                </span>
                                                            </div>
                                                        </label>
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            )}
                            <tr>
                                <td>
                                    <span>Required profile fields</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Profile fields that must be completed by the worker during registration. Please enter field names separated with a comma.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <textarea
                                        className="settings-long-textfield"
                                        rows={2}
                                        defaultValue={
                                            settingsData.REQUIRED_PROFILE_FIELDS.join(', ')
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                REQUIRED_PROFILE_FIELDS:
                                                    event.target.value.split(',').map(field => field.trim())
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Additional profile fields required only when onboarding</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Profile fields that must be completed by the worker during onboarding. Does not apply to workers that passed the interview. Please enter field names separated with a comma.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <textarea
                                        className="settings-long-textfield"
                                        rows={2}
                                        defaultValue={
                                            settingsData.REQUIRED_PROFILE_FIELDS_ONBOARDING_ONLY.join(', ')
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                REQUIRED_PROFILE_FIELDS_ONBOARDING_ONLY:
                                                    event.target.value.split(',').map(field => field.trim())
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Valid postcodes</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="The list of postal codes for automatically assigning workers who did not indicate a branch preference during registration.">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <textarea
                                        className={`settings-long-textfield ${this.state.isError ? 'error-border' : ''}`}
                                        rows={2}
                                        defaultValue={JSON.stringify(
                                            settingsData.VALID_POSTCODES,
                                        )}
                                        onBlur={event => {
                                            try {
                                                const coeff =JSON.parse(
                                                    JSON.stringify(
                                                        event.target.value,
                                                    ),
                                                );
                                                onSettingChange({
                                                    VALID_POSTCODES:
                                                        JSON.parse(coeff),
                                                });
                                                this.setState({ isError: false });
                                            } catch (error) {
                                                console.log(error);
                                                this.props.notification.error(
                                                    'Error', 'This is not a valid JSON.'
                                                );
                                                this.setState({ isError: true });
                                            }
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="system-settings-section__subtitle margin-top-10">
                        Unpublication rules
                    </div>
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Maximum number of strikes</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Maximum number of strikes workers can received before being unpublished from the platform. Set to 0 to disable strike policy entirely">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <Select
                                        value={
                                            settingsData.STRIKES_UNPUBLISH_THRESHOLD
                                        }
                                        clearable={false}
                                        onChange={option => {
                                            onSettingChange({
                                                STRIKES_UNPUBLISH_THRESHOLD:
                                                    option.value,
                                            });
                                        }}
                                        options={strikesOptions}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>
                                        Feedback score unpublication threshold
                                    </span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Minimum feedback score under which workers will be barred from the platform">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <Select
                                        value={
                                            settingsData.BAD_FEEDBACK_UNPUBLISH_THRESHOLD
                                        }
                                        clearable={false}
                                        onChange={option => {
                                            onSettingChange({
                                                BAD_FEEDBACK_UNPUBLISH_THRESHOLD:
                                                    option.value,
                                            });
                                        }}
                                        options={ratingOptions}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Feedback score grace counter</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Minimum number of feedbacks to receive before being subject to the policy above">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={0}
                                        className="duration"
                                        defaultValue={
                                            settingsData.BAD_FEEDBACK_UNPUBLISH_COUNT
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                BAD_FEEDBACK_UNPUBLISH_COUNT:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Strikes cooldown</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Number of jobs a worker must complete without issue for a strike to be voided">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <Select
                                        value={
                                            settingsData.STRIKES_VOIDING_JOBS
                                        }
                                        clearable={false}
                                        onChange={option => {
                                            onSettingChange({
                                                STRIKES_VOIDING_JOBS:
                                                    option.value,
                                            });
                                        }}
                                        options={badFeedbackOptions}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="system-settings-section__subtitle margin-top-10">
                        Matching score weights
                    </div>
                    <table className="table-settings">
                        <tbody>
                            <tr>
                                <td>
                                    <span>Global ratings</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Weight of global rating in the worker matching score">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={0}
                                        max={1}
                                        step={0.001}
                                        className="duration"
                                        defaultValue={
                                            settingsData.MATCHING_COEFFICIENT_RATING
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                MATCHING_COEFFICIENT_RATING:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Client ratings</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Weight of job client rating in the worker matching score">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={0}
                                        max={1}
                                        step={0.001}
                                        className="duration"
                                        defaultValue={
                                            settingsData.MATCHING_COEFFICIENT_CLIENT_RATING
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                MATCHING_COEFFICIENT_CLIENT_RATING:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Category ratings</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Weight of same job category ratings in the worker matching score">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={0}
                                        max={1}
                                        step={0.001}
                                        className="duration"
                                        defaultValue={
                                            settingsData.MATCHING_COEFFICIENT_CLIENT_CATEGORY
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                MATCHING_COEFFICIENT_CLIENT_CATEGORY:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Monthly activity</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Weight of worker application monthly activity in the worker matching score">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={0}
                                        max={1}
                                        step={0.001}
                                        className="duration"
                                        defaultValue={
                                            settingsData.MATCHING_COEFFICIENT_MONTHLY_ACTIVITY
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                MATCHING_COEFFICIENT_MONTHLY_ACTIVITY:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>Job distance</span>
                                    <span className="table-settings__tooltip">
                                        <Tooltip tooltip="Weight of job location <-> home in the worker matching score">
                                            <i className="icon icon-infomation-circle" />
                                        </Tooltip>
                                    </span>
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        min={0}
                                        max={1}
                                        step={0.001}
                                        className="duration"
                                        defaultValue={
                                            settingsData.MATCHING_COEFFICIENT_JOB_DISTANCE
                                        }
                                        onBlur={event => {
                                            onSettingChange({
                                                MATCHING_COEFFICIENT_JOB_DISTANCE:
                                                    event.target.value,
                                            });
                                        }}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

SuppleSettings.propTypes = propTypes;

export default SuppleSettings;
